import React from 'react';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';

export const FormFieldSelectionList = ({ value }) => (
  <div>
    {'selectionList'} :{' '}
    {value.map((value, index) => (
      <React.Fragment key={index}>
        <div>
          <ArrowRightIcon />
          <label htmlFor={index}> {value}</label>
        </div>
      </React.Fragment>
    ))}
  </div>
);
